export const metrics = [
  101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115,
  116, 201, 202, 203, 204, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215,
  216, 217, 218, 219, 220, 301, 304, 305, 306, 307, 308, 309, 310, 311, 312,
  401, 402, 403, 405, 406, 407, 408, 409, 411, 412, 501, 502, 503, 504, 505,
  506, 507, 508, 509, 510, 511, 512, 513, 514, 515, 516,
];
